import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";

const UpdateSection = (props) => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [courses, setCourses] = useState([]);
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();



    const getCourses = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetCourse";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setCourses(res.data['data']['courses'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);

        }
        setLoading(false);
    }
    const getSections = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSections";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setSections(res.data['data']['sections'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);

        }
        setLoading(false);
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/user/Opt/UpdateSection";
            await axios({
                method: 'Post',
                url: url,
                data: {
                    courseId: document.getElementById("courseId").value,

                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Şifreniz Başarıyla Değiştirilmiştir.",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                    }
                    else {
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`
                        });
                    }
                }

            });
        } catch (err) {
            alert("Beklenmedik bir hata oluştu. Lütfen tekrar deneyiniz.");
        }
        navigate("/profile");
    }
    useEffect(() => {
        getCourses();
        getSections();
    }, [getCourses, getSections]);


    return (

        <div className="container">
            <br />
            {msg}
            {!loading && (
                <form onSubmit={onSubmit} style={{ marginTop: "5%" }}>
                    <div className="mb-3">
                        <label for="sectionId" className="form-label">{t("selectSection")}</label>
                        <select id="sectionId" className="form-select">
                            <option key="" >{t("selectSection")}</option>

                            {sections ? (
                                sections && sections.map((dt) => {
                                    return (
                                        <option key={dt.id} value={dt.id}>{dt.sectionName} -- {dt.sectionDesc}</option>
                                    );
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>

                    <div className="mb-3">
                        <label for="courseId" className="form-label">{t("selectCourse")}</label>
                        <select id="courseId" className="form-select" >
                            <option key="" >{t("selectCourse")}</option>

                            {courses ? (
                                courses && courses.map((dt) => {
                                    return (
                                        <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                    );
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>


                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-primary btn-lg">{t("save")}</button>
                    </div>

                </form>

            )}
        </div>
    );
};

export default UpdateSection;